import { Routes, Route, Navigate } from 'react-router-dom'

import OEMOrderListView from 'Presentation/Views/OEM/Orders/List/View'
import InquiryDetailView from 'Presentation/Views/Inquiries/Detail/View'
import QuotationDetailView from 'Presentation/Views/Quotations/Detail/View'

import OEMProductionListView from 'Presentation/Views/OEM/Productions/List/View'
import OEMProductionDetailView from 'Presentation/Views/OEM/Productions/Detail/View'

const OEMRoutes = () => (
	<Routes>
		<Route path="orders">
			<Route index element={<OEMOrderListView />} />
			<Route path="*" element={<Navigate to="/oem/orders" replace />} />
		</Route>
		<Route path="productions">
			<Route index element={<OEMProductionListView />} />
			<Route path=":uuId" element={<OEMProductionDetailView />} />
			<Route path="*" element={<Navigate to="/oem/orders" replace />} />
		</Route>
		<Route path="inquiries">
			<Route path=":id" element={<InquiryDetailView />} />
			<Route index element={<Navigate to="/oem/orders" replace />} />
			<Route path="*" element={<Navigate to="/oem/orders" replace />} />
		</Route>
		<Route path="quotations">
			<Route path=":id" element={<QuotationDetailView />} />
			<Route index element={<Navigate to="/oem/orders" replace />} />
			<Route path="*" element={<Navigate to="/oem/orders" replace />} />
		</Route>
		<Route index element={<Navigate to="/oem/orders" replace />} />
		<Route path="*" element={<Navigate to="/oem/orders" replace />} />
	</Routes>
)

export default OEMRoutes
